export default __webpack_public_path__ + "static/media/Mace of the Cloudseer.c8eab56a.jpg";